(function () {
    'use strict';

    angular
        .module('riskSelfAssessmentReviewControllers')
        .controller('RiskSelfAssessmentReviewFinalQuestionsController', Controller);

    Controller.$inject = ['$scope', '$rootScope', '$state', 'assessmentQuestions', 'risksToReview', 'assessorId', 'commonRiskSelfAssessmentService'];

    function Controller($scope, $rootScope, $state, assessmentQuestions, risksToReview, assessorId, riskAssessmentService) {
        $scope.assessmentQuestions = assessmentQuestions;
        $scope.ctrlCtxt = {
            isPageValid: false,
            hasChanged: false,
            isSaving: false
        };
        $scope.originalQuestions = null;

        init();

        $scope.hasAssessmentBeenModified = function () {
            return $scope.ctrlCtxt.hasChanged;
        };

        $scope.answerUpdated = function () {
            // TODO When implementing reviewer edit of questions
            //$rootScope.$broadcast('page-is-dirty');
            //$scope.ctrlCtxt.hasChanged = true;
            //checkIfPageIsValid();
        };

        $scope.goToSummary = function () {
            $state.go('riskSelfAssessmentReviewByAssessor.summary', {}, { reload: true });
        };

        $scope.goToAssessors = function () {
            $state.go('riskSelfAssessmentList');
        };

        $scope.shouldHideRatingsLegend = function () {
            return true;
        };

        $scope.goToPreviousPage = function () {
            $state.go('riskSelfAssessmentReviewByAssessor.risk', { RiskID: risksToReview[risksToReview.length-1].Risk.RiskID });
        };

        $scope.isNextBtnDisabled = function () {
            return false;
        };

        $scope.goToNextPage = function () {
            $state.go('riskSelfAssessmentReviewByAssessor.summary');
        };

        $scope.isReviewAndContinueActionDisabled = function () {
            // TODO When implementing reviewer edit of questions
            return true;
            //return $scope.ctrlCtxt.isSaving || !$scope.ctrlCtxt.isPageValid;
        };

        $scope.reviewAndContinue = function () {
            // TODO When implementing reviewer edit of questions
            $scope.goToNextRiskToReview();
            //if ($scope.ctrlCtxt.isSaving) return;
            //$scope.ctrlCtxt.isSaving = true;
            //
            //if (!$scope.ctrlCtxt.hasChanged) {
            //    goToNextPage();
            //    return;
            //}
            //
            //cleanupAnswers($scope.assessmentQuestions.RiskAssessmentQuestions[2]);
            //
            //riskAssessmentService
            //    .updateAssessmentQuestions($scope.assessmentQuestions, assessorId)
            //    .then(function (riskAssessmentContainer) {
            //        $scope.assessmentQuestions = riskAssessmentContainer;
            //        init();
            //        if ($scope.ctrlCtxt.isPageValid) {
            //            goToNextPage();
            //        }
            //    })
            //    .finally(function () {
            //        $scope.ctrlCtxt.isSaving = false;
            //    });
        };

        // Go to next risk to review
        $scope.goToNextRiskToReview = function () {
            var risk = _.find(risksToReview, function (risk) {
                return !risk.Assessment || !risk.Assessment.HasFinalAssessorReviewed;
            });

            if (!_.isUndefined(risk)) {
                $state.go('riskSelfAssessmentReviewByAssessor.risk', { RiskID: risk.Risk.RiskID });
            } else {
                $state.go('riskSelfAssessmentReviewByAssessor.summary');
            }
        };

        // Go to next page - not using $scope.goToNextPage as the button is always disabled
        function goToNextPage() {
            // Find first not assessed risk
            var risk = _.find(risksToReview, function (risk) {
                return !risk.Assessment || !risk.Assessment.RiskAssessmentID;
            });

            if (!_.isUndefined(risk)) {
                $state.go('riskSelfAssessmentReviewByAssessor.assessor.riskToAssess', { RiskID: risk.Risk.RiskID });
            } else {
                $state.go('riskSelfAssessmentReviewByAssessor.summary');
            }
        }

        function checkIfPageIsValid() {
            // TODO When implementing reviewer edit of questions
            //var isValid;
            //
            //// Question 3
            //var question = $scope.assessmentQuestions.RiskAssessmentQuestions[2];
            //isValid = validateQuestion(question);
            //
            //$scope.ctrlCtxt.isPageValid = isValid;
        }

        function validateQuestion(question) {
            // TODO When implementing reviewer edit of questions
            //var isValid = true;
            //for(var i=0; i<question.MinMandatoryAnswer; i++) {
            //    var answer = question.RiskAssessmentAnswers[i];
            //    if (answer._isMandatory && !answer.AssessorValue) {
            //        isValid = false;
            //    }
            //}
            //return isValid;
        }

        function cleanupAnswers(question) {
            // TODO When implementing reviewer edit of questions
            //// Remove empty answers and reassign Depth
            //_.remove(question.RiskAssessmentAnswers, function (answer) {
            //    return !answer.AssessorValue;
            //});
            //_.each(question.RiskAssessmentAnswers, function (answer, index) {
            //    answer.Depth = index+1;
            //});
        }

        function init() {
            // TODO When implementing reviewer edit of questions
            //_.each($scope.assessmentQuestions.RiskAssessmentQuestions, function (question) {
            //    question.RiskAssessmentAnswers = question.RiskAssessmentAnswers || [];
            //    for (var i=0; i<question.MaxAnswer; i++) {
            //        if (!question.RiskAssessmentAnswers[i]) {
            //            question.RiskAssessmentAnswers.push(
            //                riskAssessmentService.createRiskAssessmentAnswer(question.RiskAssessmentQuestionID, question)
            //            );
            //        }
            //        question.RiskAssessmentAnswers[i]._isMandatory = i < question.MinMandatoryAnswer;
            //    }
            //});
            //$scope.originalQuestions = _.cloneDeep($scope.assessmentQuestions);
            //checkIfPageIsValid();
            //$scope.ctrlCtxt.isValidOnPageLoad = $scope.ctrlCtxt.isPageValid;
        }
    }
})();
